module.exports = __webpack_public_path__ + "img/back.f0a4a81c.svg";